import { useState } from "react";

const RangeSlider = (params) => {
  if (!params.disabled) { // slider that takes values from 15 to 150 to change the number of bars
    return (
      <div className="custom-range-container">
        <div className="custom-range">
          <input
            className="slider"
            type="range"
            min="15"
            max="150"
            onChange={(event) => params.setRangeval(event.target.value)}
          />
        </div>
        <h4>{params.rangeval}</h4>
      </div>
    );
  } else {
    return <div className="custom-range-container"></div>;
  }
};

export default RangeSlider;
